import { type FC } from 'react'

interface WidgetProps {
  largeBorder?: boolean
  backgroundColour?: string
  border?: string
  radius?: string
  isEvergive?: boolean
  className?: string
}
export const Widget: FC<WidgetProps> = ({ largeBorder = false, backgroundColour = 'bg-white', border = '', radius = 'rounded-xl', isEvergive = false, className = '', children }) => {
  return <div className={`p-4 ${largeBorder && 'py-6'} ${backgroundColour} ${radius} ${border || 'border border-fg-gray-820'} w-full relative ${className}`}>
        {isEvergive && <div className='h-2 w-full bg-mtd-evergive absolute top-0 left-0 rounded-t-xl'/>}
        {children}
    </div>
}
